import { Select } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const TRACKING_COMPANY_SELECT_DROPDOWN_CLASS =
  "tracking-company-select-dropdown";

export const TrackingCompanySelectDropdownStyles = createGlobalStyle`
  .${TRACKING_COMPANY_SELECT_DROPDOWN_CLASS} {
    .rc-virtual-list-holder {
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-y;
    }

    .ant-select-item,
    .ant-select-item-option-content {
      font-size: 16px !important;
      line-height: 1.4;
    }
  }
`;

export const StyleSelect = styled(Select)`
  width: 100%;
  touch-action: manipulation;
  min-width: 0;

  .ant-select-selector {
    background: var(--bg-field) !important;
    color: var(--color-field) !important;
    font-size: 16px !important;
    min-height: 40px !important;
    align-items: center;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder,
  .ant-select-selection-search-input {
    font-size: 16px !important;
    line-height: 1.4 !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  .ant-select-arrow {
    color: var(--color-field) !important;
  }
`;
